import React from 'react';
import VinicaRightTabLI from './VinicaRightTabLi';
import services from '../../../../services';
import queryString from 'query-string'

class VinicaRightTabData extends React.Component {
    /* Primeiro passo na acomodação da classe */
    constructor(props) {
        super(props);
        this.state = {
            tab: '',
            tabShowData: [],
            displayData: [],
            entity_list_object: {},
            entityListUL: null
        }
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar */

    componentDidMount() {
        console.log("right tab data mount")
        console.log(this.props)
        this.setState({
            tab: this.props.tab,
            tabShowData: this.props.tabShowData,
            displayData: this.props.displayData
        })

        this.getAllUser();
    }
    componentDidUpdate(preProp) {
        
        if (this.props.date !== preProp.date) {
            console.log("right tab data update")
            if(this.props.tab == "Utilizadores"){
                this.getAllUser();
            }else{

                let tabShowData = [...this.props.tabShowData];
                let displayData = [...this.props.displayData];
                this.setState({
                    tab: this.props.tab,
                    displayData,
                    tabShowData
                })
            }

        }
    }

    getAllUser = async () => {
        let params = queryString.parse(window.location.search)
        let idInstalacao = params.idInstalacao;
        //https://localhost:44397/api/InstalacaoVinica/GetUsers
        let link = "InstalacaoVinica/GetUsers";
        let allUser = [];
        let request = {
            idInstalacaoVinicaDecrypt: idInstalacao,
        };
        let res = await services.apiCall.requestApi(link, request, "post");
        // console.log("uuuser users ", res.codEntidade);
        if (res) {
            allUser = res;
        }
        let tabShowData = res;
        let displayData = res;
        this.setState({
            tab: "Utilizadores",
            displayData,
            tabShowData
        })
    };
    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    getEntityNumDetail = (tab, tabShowData, displayData=[]) => {
        console.log("in the li function call....", tabShowData, displayData)
        return (
            <ul className="list-unstyled mt-4">
                {
                    displayData.length === 0 ?
                    tabShowData && tabShowData.length > 0 &&
                        tabShowData.map((entity,index) => (
                        <VinicaRightTabLI
                            key={index}
                            tab={tab}
                            nif={entity.nif}
                            IdenUser={this.props.IdenUser}
                            detailClick={(id) => this.props.detailClick(id)}
                            date={new Date()}
                            getDisplayData={(row, tab) => this.props.getDisplayData(row, tab)}
                        />
                    ))
                    :
                    displayData.length > 0 &&
                    displayData.map((entity,index) => (
                        <VinicaRightTabLI
                            key={index}
                            tab={tab}
                            entity={entity}
                            nif={entity.nif}
                            IdenUser={this.props.IdenUser}
                            detailClick={(id) => this.props.detailClick(id)}
                            date={new Date()}
                            getDisplayData={(row, tab) => this.props.getDisplayData(row, tab)}
                        />
                    ))
                }
            </ul>
        )
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        return (
            <div className="tab-content">
                {
                    (this.props.tab === "Instalação") &&
                    <div className="tab-pane container active">
                        {
                            this.state.tabShowData &&
                            this.state.tabShowData.length > 0 ?
                                <div className="mb-0">
                                    {/* <img className="img-fluid" src="imgs/logo2.png" /> */}
                                    {
                                        this.getEntityNumDetail('Instalação', this.state.tabShowData, this.state.displayData)
                                    }
                                    <p className="d-flex justify-content-center align-items-center">
                                        <span data-toggle="modal" data-target='#vinica-left-popup' onClick={() => this.props.insertClickPopUp()} className="theme-color cursor-pointer custom-btn">+ Editar</span>
                                    </p>
                                </div>
                                :
                                <div className="searct-found">
                                    <img className="img-fluid" src="imgs/search-large-icon.png" />
                                    <p className="font-14">Sem proprietário definido</p>
                                    {/* <h5>Associe a entidade titular do direito ao registo</h5> */}
                                    <p className="mt-3">
                                        <span data-toggle="modal" data-target='#vinica-left-popup' onClick={() => this.props.insertClickPopUp()} className="theme-color cursor-pointer custom-btn" >+ Inserir</span>
                                    </p>
                                </div>
                        }

                    </div>
                }
                {
                    this.props.tab === "Utilizadores" &&
                    <div className="tab-pane container active">
                        
                        {
                            this.state.tabShowData &&
                            this.state.tabShowData.length > 0 ?
                                <div className="mb-0">
                                    {/* <img className="img-fluid" src="imgs/logo2.png" /> */}
                                    {
                                        this.getEntityNumDetail('Utilizadores', this.state.tabShowData, this.state.displayData)
                                    }
                                    <p className="d-flex justify-content-center align-items-center">
                                    <span data-toggle="modal" data-target='#vinica-left-popup' onClick={() => this.props.insertClickPopUp()} className="theme-color cursor-pointer custom-btn">+ Editar</span>
                                    </p>
                                </div>
                            :
                                <div className="searct-found">
                                    <img className="img-fluid" src="imgs/search-large-icon.png" />
                                    <p className="font-14">Sem  titular</p>
                                    <h5>Associe a entidade titular do direito ao registo</h5>
                                    <p className="mt-3">
                                    <span data-toggle="modal" data-target='#vinica-left-popup' onClick={() => this.props.insertClickPopUp()} style={!this.props.isInEdit?{color:"grey",border:"1px solid grey"}:{}} className="theme-color cursor-pointer custom-btn">+ Inserir</span>
                                    </p>
                                    {!this.props.isInEdit &&
                                 <center className="vinica-dados-form-alert mt-0 " > 
                                    <p className="mt-0 mb-3"> 
                                    Disponivel após gravação de dados de entidade
                                    </p>
                                </center>}
                                </div>
                        }
                    </div>
                }
            </div>
        )
    }
}

export default VinicaRightTabData;